import { mapCategories, mapSubCategories } from "./mapSportsbookCategories";
import { mapArrayElement } from "../../common";
function mapEventScorecard(data) {
    return {
        mainScorecard: mapArrayElement(data[0], mapMainScorecard),
        scoreCards: mapArrayElement(data[1], mapScorecards),
        scorecardComponentId: data[2],
    };
}
function mapScorecards(scoreCards) {
    return scoreCards.map(mapScorecard);
}
function mapScorecard(data) {
    return {
        intervalName: data[1],
        intervalNumber: data[2],
        firstTeamScore: data[3],
        secondTeamScore: data[4],
        liveInfo: data[5],
        liveScoreData: data[6],
    };
}
function mapMainScorecard(data) {
    return Object.assign(Object.assign({}, mapScorecard(data)), { metadata: data[8] });
}
function mapLiveGameState(data) {
    return {
        period: data[0],
        gameTime: data[1],
        isClockRunning: data[2],
    };
}
function mapParticipants(participants) {
    return participants.map(data => ({
        id: data[0],
        name: data[1],
        venueRole: data[2],
        type: data[3],
        metadata: data[4],
        sortOrder: data[5],
        seoIdentifier: data[6],
    }));
}
function mapEventMedias(eventMedias) {
    return eventMedias.map(data => ({
        providerName: data[0],
        providerEventId: data[1],
        mediaType: data[2],
        metadata: data[3],
        allowedDmas: data[4],
    }));
}
export function mapSportsbookEventUpdate(data) {
    return {
        id: data[0],
        startEventDate: data[1],
        participants: mapArrayElement(data[2], mapParticipants),
        status: data[3],
        liveGameState: mapArrayElement(data[4], mapLiveGameState),
        eventScorecard: mapArrayElement(data[5], mapEventScorecard),
        tags: data[6],
        metadata: data[7],
        sortOrder: data[8],
    };
}
export function mapSportsbookEventPull(data) {
    return {
        id: data[0],
        seoIdentifier: data[1],
        name: data[2],
        startEventDate: data[3],
        participants: mapArrayElement(data[4], mapParticipants),
        eventParticipantType: data[5],
        status: data[6],
        liveGameState: mapArrayElement(data[7], mapLiveGameState),
        eventScorecard: mapArrayElement(data[8], mapEventScorecard),
        media: mapArrayElement(data[9], mapEventMedias),
        tags: data[10],
        metadata: data[11],
        categories: mapCategories(data[12]),
        subcategories: mapSubCategories(data[13]),
        sportId: data[14],
        leagueId: data[15],
        sortOrder: data[16],
    };
}
//# sourceMappingURL=mapSportsbookEvent.js.map